import { isAnyOf, Middleware } from "@reduxjs/toolkit";
import { State } from "../state/types";
import { getSteps } from "components/Signup/steps";
import {
  addAnimal,
  commitAnimalById,
  editAnimalById,
  editDraftsByAnimalId,
  updateAnimalById,
} from "../slices/animals";
import { updateRoute } from "./utils/updateRoute";
import { selectAnimalById } from "../selectors/animals";
import { isValidAnimal } from "components/Signup/steps/validations/animal";
import { StepName } from "components/Signup/steps/types";
import { selectCurrentInsuranceByAnimalId } from "../selectors/insurance";
import { SignUpProductEnum } from "components/Signup/flow/SignupFlow/types";
import { isOrg } from "utils/site";

const steps = getSteps();

export const animalsMiddleware: Middleware<{}, State> =
  (storeApi) => (next) => async (action) => {
    const result = next(action);

    if (isAnyOf(addAnimal)(action)) {
      const state = storeApi.getState();

      // Redirect to the last animal
      const id = state.animals[state.animals.length - 1].id;

      // In Sweden we skip over flytthjälpen when adding another animal
      const nextStepName: StepName = isOrg("swe") ? "species" : steps[0].name;

      updateRoute({
        route: `${nextStepName}/${id}`,
        state: storeApi.getState(),
        replace: false,
      });
    }

    if (isAnyOf(updateAnimalById)(action)) {
      const animal = selectAnimalById(storeApi.getState(), action.payload.id);

      if (animal && isValidAnimal(animal)) {
        storeApi.dispatch(commitAnimalById(action.payload.id));
      }
    }

    if (isAnyOf(editAnimalById)(action)) {
      updateRoute({
        route: `${steps[0].name}/${action.payload}`,
        state: storeApi.getState(),
        replace: false,
      });
    }

    if (isAnyOf(editDraftsByAnimalId)(action)) {
      const state = storeApi.getState();
      const insurance = selectCurrentInsuranceByAnimalId(state, action.payload);
      const step: StepName =
        insurance.product === SignUpProductEnum.liability
          ? "liability-quote-preview"
          : "quote-preview";

      updateRoute({
        route: `${step}/${action.payload}`,
        state: storeApi.getState(),
        replace: false,
      });
    }

    return result;
  };
